import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	container: {
		"& .mco-extension-component-services__item + .mco-extension-component-services__item": {
			borderTop: "1px solid #707070",
			marginTop: 25,
			paddingTop: 25
		},
		[theme.breakpoints.up("lg")]: {
			display: "flex",
			"& .mco-extension-component-services__item + .mco-extension-component-services__item": {
				borderTop: 0,
				borderLeft: "1px solid #707070",
				marginTop: 0,
				paddingTop: 0
			}
		}
	}
}));

export default styles;
